var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPomegranate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004137;}\n\t.st1{fill:#E51E37;}\n\t.st2{fill:#A91B27;}\n\t.st3{fill:#EC635D;}\n\t.st4{display:none;fill:#F4A49B;}\n\t.st5{fill:#F39200;}\n\t.st6{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.32,83.46l9.53-19.56l-11.26,4.54l0.73-14.32l-13.35,10.68l-5.1-14.32l-5.58,9.83L95.86,47.9l0.19,28.13 c0,0,1.35-0.27-0.23,0.01c-16.44,2.9-29.83,14.3-33.05,30.08c-4.36,21.35,11.55,42.62,35.53,47.52c23.98,4.89,46.94-8.45,51.3-29.8 c3.17-15.53-4.41-30.98-17.99-40.15C130.67,83.04,131.32,83.46,131.32,83.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.89,86.89l9.94-17.4l-9.18,6.12l0.61-12.03l-11.22,8.97l-4.28-12.03l-4.28,8.57l-5.91-9.59l0.75,22 c-15.63,1.14-28.86,11.25-31.82,25.79c-3.66,17.95,9.71,35.83,29.86,39.94c20.15,4.11,39.46-7.1,43.12-25.05 C145.33,108.21,137.84,94.32,124.89,86.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.65,87.78c0,0-9,0.73-11.93,1.29s-9.73,5.32-12.48,9.18c-2.75,3.86-3.21,7.16-3.12,11.75 s-0.64,8.08,1.47,13.22c2.11,5.14,3.17,7.21,6.86,8.06c3.69,0.85,5.53-0.35,7.27,2.59s3.12,5.14,5.32,6.43 c2.2,1.29,7.07,1.84,9.18,1.47c2.11-0.37,2.75-1.38,4.41-0.55c1.65,0.83,4.04-0.83,4.96-2.02c0.92-1.19,0.55-0.92,2.2-2.02 s3.67-3.86,5.51-5.14s3.95-0.55,5.88-1.47c1.93-0.92,5.42-8.54,6.06-12.48s-0.73-3.76-0.18-5.88c0.55-2.11,1.38-6.88-1.47-10.28 c-2.85-3.4-7.26-7.67-9.09-8.9C115.77,87.78,108.52,87.32,102.65,87.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9818 -0.1901 0.1901 0.9818 -22.6744 20.2678)",
    className: "st3",
    cx: 94.33,
    cy: 128.35,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 94.7,
    cy: 126.72,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9818 -0.1901 0.1901 0.9818 -21.262 21.1631)",
    className: "st3",
    cx: 99.71,
    cy: 121.43,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 100.08,
    cy: 119.8,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8509 -0.5253 0.5253 0.8509 -51.5181 80.3471)",
    className: "st3",
    cx: 115.79,
    cy: 130.93,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 115.56,
    cy: 129.28,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8509 -0.5253 0.5253 0.8509 -46.0299 78.9345)",
    className: "st3",
    cx: 116.05,
    cy: 120.56,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 115.82,
    cy: 118.9,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2176 -0.976 0.976 0.2176 -14.4713 205.4848)",
    className: "st3",
    cx: 120.94,
    cy: 111.77,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 119.59,
    cy: 110.78,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5532 -0.8331 0.8331 0.5532 -41.647 159.0309)",
    className: "st3",
    cx: 127.42,
    cy: 118.34,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 126.52,
    cy: 116.93,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -48.2791 138.5313)",
    className: "st3",
    cx: 108.76,
    cy: 115.58,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 107.89,
    cy: 114.15,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -29.115 138.5884)",
    className: "st3",
    cx: 118.39,
    cy: 97.22,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 117.52,
    cy: 95.79,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -64.8721 146.1864)",
    className: "st3",
    cx: 107.8,
    cy: 135.33,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 106.93,
    cy: 133.89,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -35.5651 153.3021)",
    className: "st3",
    cx: 129.28,
    cy: 110.77,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 128.41,
    cy: 109.34,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8509 -0.5253 0.5253 0.8509 -47.8566 84.0238)",
    className: "st3",
    cx: 124.1,
    cy: 126.32,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 123.87,
    cy: 124.66,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9818 -0.1901 0.1901 0.9818 -22.0267 22.8197)",
    className: "st3",
    cx: 107.96,
    cy: 126.25,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 108.33,
    cy: 124.62,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8568 -0.5156 0.5156 0.8568 -42.9742 67.6434)",
    className: "st3",
    cx: 100.31,
    cy: 111.2,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 100.1,
    cy: 109.54,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8143 -0.5804 0.5804 0.8143 -40.3567 85.6312)",
    className: "st3",
    cx: 113.66,
    cy: 105.89,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 113.32,
    cy: 104.25,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -30.296 147.336)",
    className: "st3",
    cx: 126.19,
    cy: 102.73,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 125.32,
    cy: 101.3,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -36.7377 64.3457)",
    className: "st3",
    cx: 104.73,
    cy: 102.45,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 104.56,
    cy: 100.78,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -32.115 63.9104)",
    className: "st3",
    cx: 106.2,
    cy: 93.39,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 106.04,
    cy: 91.72,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -33.7534 59.8243)",
    className: "st3",
    cx: 97.57,
    cy: 94.48,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 97.41,
    cy: 92.81,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -53.9424 66.0602)",
    className: "st3",
    cx: 99.4,
    cy: 136.22,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 99.24,
    cy: 134.55,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5728 -0.8197 0.8197 0.5728 -44.5112 121.8978)",
    className: "st3",
    cx: 94.68,
    cy: 103.65,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93.81,
    cy: 102.22,
    r: 1.72
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.55,84.69l2.14-13.77l1.94,2.35l2.14-3.16l2.04,6.83l2.65-2.96l0.92,2.96l5-3.67l-0.92,3.88l3.67-0.71 l-6.51,11.4l-4.1-1.48c-0.42-0.15-2.09-0.63-4.27-1.16L107.55,84.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -36.2231 55.3656)",
    className: "st3",
    cx: 87.8,
    cy: 96.98,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 87.64,
    cy: 95.31,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -41.1337 55.7385)",
    className: "st3",
    cx: 86.06,
    cy: 106.56,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 85.9,
    cy: 104.89,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -44.4518 59.4676)",
    className: "st3",
    cx: 91.54,
    cy: 114.77,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 91.38,
    cy: 113.1,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -45.3595 54.5015)",
    className: "st3",
    cx: 81.58,
    cy: 114.02,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 81.42,
    cy: 112.36,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8721 -0.4893 0.4893 0.8721 -48.7675 58.3842)",
    className: "st3",
    cx: 87.31,
    cy: 122.48,
    rx: 3.93,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 87.15,
    cy: 120.82,
    r: 1.72
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPomegranate);
export default __webpack_public_path__ + "static/media/Pomegranate.95cb8751a6fc3fe24c207419629874f4.svg";
export { ForwardRef as ReactComponent };